import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { getToken, setToken } from '@/lib/apiClient';

const ProtectedRoute = ({ children }) => {
  const auth = useAuth();
  const location = useLocation();

  if (!auth) {
     return (
      <div className="flex items-center justify-center h-screen bg-slate-100 dark:bg-slate-900">
        <div className="flex flex-col items-center">
          <svg className="animate-spin h-16 w-16 text-sky-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          <p className="mt-4 text-lg font-semibold text-slate-700 dark:text-slate-300">Inicializando autenticación...</p>
        </div>
      </div>
    );
  }

  const { user, loading } = auth;


  // Special-case: printing routes can carry auth in the URL hash (#at=TOKEN) and should render even before /auth/me finishes.
  const hashMatch = (location.hash || '').match(/[#&]at=([^&]+)/);
  if (hashMatch && hashMatch[1]) {
    const token = decodeURIComponent(hashMatch[1]);
    if (token && !getToken()) {
      try { setToken(token); } catch { /* ignore */ }
    }
    return children;
  }
  // If token already exists and we're on a print route, allow rendering while auth context catches up.
  if (getToken() && /^\/print\//.test(location.pathname)) {
    return children;
  }

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen bg-slate-100 dark:bg-slate-900">
        <div className="flex flex-col items-center">
          <svg className="animate-spin h-16 w-16 text-sky-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          <p className="mt-4 text-lg font-semibold text-slate-700 dark:text-slate-300">Verificando autenticación...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;